// extracted by mini-css-extract-plugin
export default {"list":"BrandFilterList_list__LpFtX","item":"BrandFilterList_item__Va-OA"};